import { RelationType } from 'ogp/hooks/queryHooks/flexWorkers/useGetFlexWorkerProfile';
import { useTranslation } from 'react-i18next';
import { CancelledColumnDefinitionProject } from '../types/cancelled-table-project.types';
import { getProjectCancelationReason } from '../helper';
import { ProjectCancellation } from '../../../../../services/project-service.types';

export const useGetCancelledTableDataProject = (
  cancellations: ProjectCancellation[],
  hourlyRateCents: number
): CancelledColumnDefinitionProject[] => {
  const { t } = useTranslation('web-common');
  const cancelledPlacements = cancellations.filter((cancellation) =>
    ['canceled', 'terminated', 'completed', 'denied'].includes(cancellation.state)
  );
  const result = cancelledPlacements.map((cancelledPlacement) => {
    const { flexWorker } = cancelledPlacement;
    return {
      flexWorkerImage: {
        id: flexWorker.id,
        firstName: flexWorker.firstName,
        lastName: flexWorker.lastName,
        imageUrl: undefined,
        relation: {
          id: cancelledPlacement.relation.id,
          relation:
            cancelledPlacement.relation.relation === 'placement'
              ? RelationType.PLACEMENT
              : RelationType.SHIFTAPPLICATION,
        },
        hasCandidateLevel: flexWorker.hasCandidateLevel ?? false,
        employmentType: flexWorker.employmentType,
      },
      cancellationReason: t(getProjectCancelationReason(cancelledPlacement), { ns: 'web-common' }),
      actions: cancelledPlacement,
      flexPoolIndicator: false,
      flexWorkerFullName: flexWorker.fullName,
      hourlyRate: hourlyRateCents / 100,
    };
  });

  return result;
};
